import { SNACKBAR, ERROR_SNACKBAR, RESET_SNACKBAR } from '../mutation-types';

const state = {
  options: {
    status: false,
    text: 'asd',
    mode: ''
  }
}

const getters = {
  snackbar: state => {
    return state.options;
  }
}

const actions = {
  showSnackbar({ commit }, data) {
    commit(SNACKBAR, data);
  },
  errorSnackbar({ commit }, error) {
    commit(ERROR_SNACKBAR, error);
  },
  resetSnackbar({ commit }) {
    commit(RESET_SNACKBAR);
  }
}

const mutations = {
  [SNACKBAR] (state, payload) {
    state.options = {
      status: true,
      text: payload,
      color: 'green'
    }
  },
  [ERROR_SNACKBAR] (state, payload) {
    state.options = {
      status: true,
      text: payload,
      color: 'red'
    }
  },
  [RESET_SNACKBAR] (state) {
    state.options = {
      status: false,
      text: ''
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}